// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"d85a09c7","715":"35871c60"}[chunkId] + ".chunk.js";
};